// src/App.jsx
import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react'; // 👈 agrega esto
import { FloatingWhatsApp } from 'react-floating-whatsapp';

import Home from './layouts/home/home';
import About from './layouts/about/about';
import ContactLayout from './layouts/contact/contact';
import Shop from './layouts/shop/shop';
import CategoryPage from './layouts/shop/CategoryPage';
import ProductDetailPage from './layouts/shop/ProductDetailPage';
import CartDetail from './layouts/shop/cartDetails/cartDetail';
import LoginForm from './layouts/shop/authShop/LoginForm';
import RegisterForm from './layouts/shop/authShop/RegisterForm';
import UserProfile from './layouts/shop/userProfile/UserProfile';
import Checkout from './layouts/shop/cartDetails/checkout/checkout';
import PaymentResult from './components/checkout/paymentResult/PaymentResult';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RecuperarPasswordForm from './layouts/shop/authShop/RecuperarPasswordForm';
import ResetPassword from './layouts/shop/authShop/ResetPassword';
import WishlistPage from './layouts/shop/wishlist/WishlistPage';
import BrandPage from './layouts/shop/BrandPage';
import CategoryProductsPage from './layouts/shop/CategoryProductsPage';
import SearchResults from './layouts/shop/SearchResults';
import HistorialPedidos from './layouts/shop/userProfile/HistorialPedidos';
import Marcas from './layouts/shop/marcas/marcas';
import ShopGlobalToast from './components/shop/ShopGlobalToast';
import ShopCatalogHelpToast from './components/shop/ShopCatalogHelpToast';
import GlobalPageLoader from './components/shop/GlobalPageLoader';
import './App.css';

function App() {
  const location = useLocation();
  const toastVisibilityPreset = 'prominent';
  const [bootLoading, setBootLoading] = useState(true);
  const [routeLoading, setRouteLoading] = useState(true);

  useEffect(() => {
  window.scrollTo(0, 0);
}, [location.pathname]);

  useEffect(() => {
    let timerId;

    const completeBoot = () => {
      timerId = window.setTimeout(() => setBootLoading(false), 550);
    };

    if (document.readyState === 'complete') {
      completeBoot();
    } else {
      window.addEventListener('load', completeBoot, { once: true });
    }

    return () => {
      window.removeEventListener('load', completeBoot);
      window.clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    setRouteLoading(true);
    const timerId = window.setTimeout(() => setRouteLoading(false), 420);

    return () => window.clearTimeout(timerId);
  }, [location.pathname]);

  // Rutas donde NO se debe mostrar el botón
  const hideWhatsAppOn = [
    
    '/loginVpStore',
    '/registerVpStore',
    '/recuperar-password',
    '/reset-password',
    '/checkout',
    '/checkout/payment-result',
  ];

  const shouldShowWhatsApp = !hideWhatsAppOn.includes(location.pathname);
  const isGlobalLoading = bootLoading || routeLoading;

  return (
    <>
      {isGlobalLoading && <GlobalPageLoader />}

      {shouldShowWhatsApp && !isGlobalLoading && (
        <FloatingWhatsApp
          phoneNumber="573012201583"
          accountName="Vintage Pro Audio"
          avatar="images/waVPA.jpg"
          chatMessage="¡Hola! ¿En qué puedo ayudarte?"
          statusMessage="En línea"
          placeholder="Escribe un mensaje"
          darkMode={false}
          notification
          notificationSound
          allowClickAway
        />
      )}

      {!isGlobalLoading && (
        <>
          <ShopGlobalToast preset={toastVisibilityPreset} />
          <ShopCatalogHelpToast preset={toastVisibilityPreset} />
        </>
      )}

      {!isGlobalLoading && <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contacto" element={<ContactLayout />} />
        <Route path="/tienda" element={<Shop />} />
        <Route path="/tienda/:categoryId" element={<CategoryPage />} />
        <Route path="/producto/:productId" element={<ProductDetailPage />} />
        <Route path="/cartDetail" element={<CartDetail />} />
        <Route path="/loginVpStore" element={<LoginForm />} />
        <Route path="/registerVpStore" element={<RegisterForm />} />
        <Route path="/recuperar-password" element={<RecuperarPasswordForm />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/marcas/:brandId" element={<BrandPage />} />
        <Route path="/categorias/:categoryId" element={<CategoryProductsPage />} />
        <Route path="/buscar" element={<SearchResults />} />
        <Route path="/marcas" element={<Marcas />} />

        <Route
          path="/mi-cuenta"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout/payment-result"
          element={
            <ProtectedRoute>
              <PaymentResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mi-cuenta/pedidos"
          element={
            <ProtectedRoute>
              <HistorialPedidos />
            </ProtectedRoute>
          }
        />
      </Routes>}
    </>
  );
}

export default App;

